'use client';
import { VariantSelector } from 'components/bundles/addons/variant-selector';
import { addItem } from 'components/cart/actions';
import { Spinner } from 'flowbite-react';
import { ProductReference, ProductVariant, ShopifyDiscount } from 'lib/shopify/types';
import Image from 'next/image';
import Link from 'next/link';
import { startTransition, useState } from 'react';
import { cn } from 'utils/cn';
import { CurrencyType, mapCurrencyToSign } from 'utils/mapCurrencyToSign';
import { shopifyRound } from 'utils/shopifyRound';
interface collectionDiscountsProps {
    percentage: number;
    amount: number;
}
export function AddonItem({collectionHandle, addon, discount, productDiscounts, collectionDiscounts}: {collectionHandle: string, addon: ProductReference, discount: number, productDiscounts: ShopifyDiscount[], collectionDiscounts: collectionDiscountsProps}){
    const {title, priceRangeV2: {minVariantPrice: {amount: minAmount, currencyCode}}, featuredImage, collections, handle} = addon
    const addonCollections = collections.edges.map(({node}) => node)
    const isCollectionActive = collectionHandle ? addonCollections.find(collection => collection.handle === collectionHandle) : addonCollections.find(collection => collection.handle === 'best-sellers')
    const findProductDiscountByProduct = productDiscounts.find(discount => discount.customerGets?.items?.products?.edges.find(product => product.node.handle === handle))
    const discountByProductPercentage = findProductDiscountByProduct?.customerGets?.value?.percentage ?? 0
    const discountValueByPercentage = collectionDiscounts.percentage > 0 ? collectionDiscounts.percentage : 0
    const discountByProductAmount = findProductDiscountByProduct?.customerGets?.value?.amount?.amount ?? 0
    const discountValueByAmount = collectionDiscounts.amount > 0 ? collectionDiscounts.amount : 0
    
    const calculatePricePercentage = shopifyRound((Number(minAmount) * discountValueByPercentage), 2)
    
    const hasDiscount = discountValueByPercentage > 0 || discountValueByAmount > 0
    const discountedItem = discountValueByPercentage > 0 ? (Number(minAmount) - calculatePricePercentage).toFixed(2) : (Number(minAmount) - discountValueByAmount).toFixed(2)
    const variants = addon.variants.edges.map((edge) => edge.node);
    const variant = variants.find((variant: ProductVariant) => variant.title === addon.title) || variants[0]!;
    const [selectedVariant, setSelectedVariant] = useState(variant)
    const defaultVariantId = variants[0]!.id
    const selectedVariantId = selectedVariant?.id || defaultVariantId;


    const [loading, setLoading] = useState(false)
    const addToCartTransition = async()=>{
        setLoading(true)
        startTransition(async() => {
          const message = await addItem(null,selectedVariantId)
          setLoading(false)
        })
      }
    return (
        <div className={cn('text-fp-gray border-gray-200 border rounded-[4px] py-2 px-4 flex flex-row md:flex-row justify-between items-center md:items-end relative bg-white', {'hidden' : !isCollectionActive })}>
            <div className='flex w-full flex-col items-center md:items-start md:flex-row h-full'>
                <div className=''>
                    <Image src={featuredImage.url} alt={featuredImage.altText ?? addon.title} width={100} height={100} className='w-[100px] h-[100px] object-contain'/>
                </div>
                <div className='flex flex-col justify-center py-2 items-center h-full mx-2'>
                    <h5 className='font-medium text-xl'><Link scroll={false} href={`/products-modal/${addon.handle}`}>{title}</Link></h5>
                    <div className='flex w-full'>
                        <div>
                            <del 
                                aria-label={`Original price: ${mapCurrencyToSign(currencyCode as CurrencyType)}${minAmount}`}
                            >
                                {mapCurrencyToSign(currencyCode as CurrencyType)}{minAmount}
                            </del>
                        </div>
                        {hasDiscount && (
                            <div className='ml-4'>
                                <ins 
                                    className="no-underline"
                                    aria-label={`Sale price: ${mapCurrencyToSign(currencyCode as CurrencyType)}${discountedItem}`}
                                >
                                    {mapCurrencyToSign(currencyCode as CurrencyType)}{discountedItem}
                                </ins>
                            </div>
                        )}
                    </div>
                    <div className='mt-2'>
                        <VariantSelector product={addon} selectedVariant={selectedVariant} action={setSelectedVariant}/>
                    </div>
                </div>
            </div>
            <button 
                className='flex items-center h-full mt-6 md:mt-0' 
                onClick={addToCartTransition} 
                disabled={loading}
                aria-label="Add to cart"
            >
                {loading ? <Spinner aria-label="Large spinner" size="lg" /> : 
                    <div className='pl-4 flex items-center border-l-[1px] border-gray-200 h-3/4'>
                        <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M35 20.4997H5H35Z" fill="white"/>
                            <path d="M28.3333 13.833L35 20.4997M35 20.4997L28.3333 27.1663M35 20.4997H5" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                }
            </button>
        </div>
    )
}